import React from 'react';
import PaymentResult from './PaymentResult';

export default function FailedPayment() {
  return <PaymentResult status="failed" />;
}